import * as React from 'react';
import { cn } from '@/shared/lib/utils';

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => {
  return (
    <label
      ref={ref}
      data-th-typography="form-label"
      className={cn('block text-form-label text-label', className)}
      {...props}
    />
  );
});

Label.displayName = 'Label';

export default Label;
